export default __webpack_public_path__ + "static/media/beach-ball.c7c333c9.svg";